module.exports = __webpack_public_path__ + "img/top-up.6ef394fb.png";